import { Paginator } from '@app/classes';
import { ImportIntegrationEmployee } from '@app/models/import/import-integration-employee.model';
import { ImportIntegration } from '@app/models/import/import-integration.model';
import { Table } from '@app/modules/table/classes/table.class';
import { EmployeeImportMetadata } from '@app/types/metadata.type';
import * as Columns from './columns';

export class ImportEmployeeTable extends Table<ImportIntegrationEmployee, EmployeeImportMetadata> {
    constructor(
        private integration: ImportIntegration,
        private validate: { shouldValidate: boolean } = { shouldValidate: true }
    ) {
        super();
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new Columns.FirstNameColumn(),
            new Columns.LastNameColumn(),
            new Columns.EmailColumn(),
            new Columns.TitleColumn(),
            new Columns.DepartmentColumn(),
            new Columns.HiredAtColumn(),
            new Columns.RolePermissionsColumn(),
            new Columns.EmploymentTypeColumn(),
            new Columns.OfficeNameColumn(),
        ];
    }

    setDataSource(): void {
        const query = ImportIntegrationEmployee.query().param('integrationId', this.integration.id);
        if (this.validate) {
            query.queryParams('validate', this.validate.shouldValidate ? 1 : 0);
        }
        this.paginator = new Paginator(query);
    }
}
